import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  InfoCircleLine as InfoCircleIcon,
  Lightbulb as LightbulbIcon,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { NodeUITrigger } from 'modules/workflows/components/Node/types'

import { BasicInputs } from './partials/BasicInputs'
import { SidepanelHeader } from './partials/SidepanelHeader'
import { SidepanelWrapper } from './partials/SidepanelWrapper'

type Props = {
  node: NodeUITrigger
}

const TriggerNodeSidepanel = ({ node }: Props) => {
  if (node.type !== 'trigger') return null

  return (
    <SidepanelWrapper
      header={
        <SidepanelHeader
          nodeId={node.id}
          backgroundColor="#FFD7DF"
          icon={
            <LightbulbIcon width={22} height={22} style={{ color: '#AD0023', strokeWidth: 1.5 }} />
          }
          title={i18n.t('workflows.sidepanel.trigger.edit_title')}
          showDeleteButton={false}
        />
      }
    >
      <BasicInputs
        titleLabel={i18n.t('workflows.sidepanel.trigger.block_title')}
        titlePlaceholder={i18n.t('workflows.sidepanel.trigger.block_title')}
        defaultCollapsed={false}
        descriptionLabel={i18n.t('workflows.sidepanel.trigger.block_description')}
        descriptionPlaceholder={i18n.t('workflows.sidepanel.trigger.block_description')}
        readonly
        hideDivider
      />

      <Box
        flexDirection="row"
        borderRadius={{ all: 'abs012' }}
        background="neutralBackgroundSubtlest"
        padding="s12"
        gap="s12"
        alignItems="flexStart"
      >
        <Box
          padding="s4"
          border={{ all: { width: 's1', color: 'grey300', style: 'solid' } }}
          width="fit-content"
          borderRadius={{ all: 'abs012' }}
        >
          <InfoCircleIcon width={18} height={18} style={{ strokeWidth: 1 }} />
        </Box>

        <Box gap="s2" flexDirection="column">
          <Text size="200" weight="semibold" color="textSecondary">
            {i18n.t('workflows.sidepanel.trigger.cannot_edit.title')}
          </Text>
          <Text size="200" color="textSecondary">
            {i18n.t('workflows.sidepanel.trigger.cannot_edit.description')}
          </Text>
        </Box>
      </Box>
    </SidepanelWrapper>
  )
}

export default TriggerNodeSidepanel
